import { render } from "./FileInput.vue?vue&type=template&id=00398c0a"
import script from "./FileInput.vue?vue&type=script&lang=js"
export * from "./FileInput.vue?vue&type=script&lang=js"

import "./FileInput.vue?vue&type=style&index=0&id=00398c0a&lang=scss"
script.render = render

export default script